import React, { useEffect, useState, useRef } from "react";
import infoIcon from "../../../../../assets/images/Icons/info_icon.svg";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  matchValidateVersi,
} from "../../../../../helpers/global_helper";
import { useSelector, useDispatch } from "react-redux";
import ConfirmBetDeskonPopup from "../../../../Popups/ConfirmBetDeskonPopup";
import BetSuccessPopup from "../../../../Popups/BetSuccessPopup";
import ErrorPopup from "../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../Popups/ErrorInnerPopup";
import { formatPricewithdecimal, formatPrice } from "../../../../NumberFormat";
import { withTranslation } from "react-i18next";
import CancelledBetDeskonPopup from "../../../../Popups/CancelledBetDeskonPopup";
import { getUserBalance, setCommonConfig } from "../../../../../redux/actions";
import GameClosedPopup from "../../GameClosedPopup";
import MarketClose from "../../MarketClose";

const TengahVersiWap = (props) => {
  const dispatch = useDispatch();
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType = useSelector((state) => state.CommonConfig.gameType);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [showTooltip, setShowTooltip] = useState(false);
  const [tengahVal, setTengahVal] = useState({});
  const [tepiVal, setTepiVal] = useState({});
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [totalCountClick, setTotalCountClick] = useState(false);
  const [calculateTotal, setCalculateTotal] = useState({
    gameId: null,
    gameType: "tengahtepi",
    fastbet: true,
  });
  const [RespCalculateTotal, setRespCalculateTotal] = useState({});
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [reqSubmitData, setReqSubmitData] = useState({
    gameId: null,
    action: "process",
    gameType: "tengahtepi",
    fastbet: true,
    dataangka: [],
    betTogelAuth: "betTogelAuth",
  });
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [SubmitRespData, setSubmitRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);

  const tengahInputRef = useRef(null);
  const tepiInputRef = useRef(null);

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  const handleInputChange = (e, Type) => {
    const { name, value } = e.target;
    if (Type === "Tengah") {
      setTengahVal((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      setTepiVal((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    setCalculateTotal((prevReqData) => ({
      ...prevReqData,
      gameId: gameId,
      databet_tengah: tengahVal["Tengah"],
      databet_tepi: tepiVal["Tepi"],
      multiple:betDiscount.showMultiple,
    }));
  }, [tengahVal, tepiVal]);
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitCalculateTotal = () => {
    if (!calculateTotal["databet_tengah"] && !calculateTotal["databet_tepi"]) {
      setErrorMessage(props.t("format_input"));
      setShowErrorPopup(true);
      return;
    }

    let matchValidate = matchValidateVersi(gameType, calculateTotal);
    if (matchValidate) {
      if (matchValidate == "format_input") {
        setErrorMessage(props.t(matchValidate));
        setShowErrorPopup(true);
        return;
      } else {
        setErrorMessage(props.t("format_input_on") + " " + matchValidate);
        setShowErrorPopup(true);
        return;
      }
    }

    makeAjax(url.TOGEL_API.processDataBet, calculateTotal).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
        if (response.code !== "validation_error") {
          showMessage(props.t(response.code), "error", "error");
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      setRespCalculateTotal(response.data);
      setTotalCountClick(true);
      const newAngakas = [];
      response.data.dataangka.forEach((item) => {
        const newAngaka = [item.nomor, item.taruhan, item.status];
        newAngakas.push(newAngaka);
      });
      setReqSubmitData((prevState) => ({
        ...prevState,
        gameId: gameId,
        dataangka: newAngakas,
      }));
    });
  };

  useEffect(() => {
    allDataReset();
  }, [gameId]);

  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };

  const allDataReset = () => {
    setTengahVal({});
    setTepiVal({});
    setRespCalculateTotal({});
    setCalculateTotal({
      gameId: null,
      gameType: "tengahtepi",
      fastbet: true,
    });
    setReqSubmitData({
      gameId: null,
      action: "process",
      gameType: "tengahtepi",
      fastbet: true,
      dataangka: [],
      betTogelAuth: "betTogelAuth",
    });
    setTotalCountClick(false);
    if (tengahInputRef.current) tengahInputRef.current.value = "";
    if (tepiInputRef.current) tepiInputRef.current.value = "";
    setSubmitRespData([]);
  };

  const submitProcess = (event) => {
    if (totalCountClick) {
      setShowConfirmationPopup(true);
    } else {
      if (
        !calculateTotal["databet_tengah"] &&
        !calculateTotal["databet_tepi"]
      ) {
        setErrorMessage(props.t("format_input"));
        setShowErrorPopup(true);
        return;
      }
      let matchValidate = matchValidateVersi(gameType, calculateTotal);
      if (matchValidate) {
        if (matchValidate == "format_input") {
          setErrorMessage(props.t(matchValidate));
          setShowErrorPopup(true);
          return;
        } else {
          setErrorMessage(props.t("format_input_on") + " " + matchValidate);
          setShowErrorPopup(true);
          return;
        }
      }
      makeAjax(url.TOGEL_API.processDataBet, calculateTotal).then(
        (response) => {
          if (response.status !== respStatus["SUCCESS"]) {
            if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
            if (response.code !== "validation_error") {
              showMessage(props.t(response.code), "error", "error");
              return;
            }
            showMessage("server error No data find", "error", "error");
            return;
          }
          setRespCalculateTotal(response.data);
          const newAngakas = [];
          response.data.dataangka.forEach((item) => {
            const newAngaka = [item.nomor, item.taruhan, item.status];
            newAngakas.push(newAngaka);
          });
          setReqSubmitData((prevState) => ({
            ...prevState,
            gameId: gameId,
            dataangka: newAngakas,
          }));
          setShowConfirmationPopup(true);
        }
      );
    }
    // if (reqSubmitData.dataangka.length > 0) {
    //   setShowConfirmationPopup(true);
    // }
    // else {
    //   setErrorMessage('Incorrect Input Format')
    //   setShowErrorPopup(true)
    // }
  };
  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    makeAjax(url.TOGEL_API.processAltTogel, reqSubmitData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
        if (response.code !== "validation_error") {
          setErrorMessage(props.t(response.code))
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      allDataReset();
      setSubmitRespData((prevData) => [...prevData, response.data]);
      dispatch(getUserBalance());
      setSuccessPopup(true);
    });
  };

  return (
    <div className="versiwrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {/* --- Rules ---  */}
          <div className="rules_container">
            <div>
              <p>{props.t('tengah_dasar_tengah_text')}</p>
              <p>Format Tarun: Nominal taruhan sesuai konversi</p>
              <p>Conoth Penulisan: 1 pada tengah atau tepi</p>
            </div>
            <div className="rules_conversion">
              <p>
                Konversi <br /> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>
          {/* --- Rules ---  */}
          <div className="versicontainer_new">
            <p>Tengah</p>
            <textarea
              rows="7"
              placeholder="1 pada tengah"
              name="Tengah"
              ref={tengahInputRef}
              onChange={(e) => handleInputChange(e, "Tengah")}
            ></textarea>
          </div>
          <div className="versicontainer_new">
            <p>Tepi</p>
            <textarea
              rows="7"
              placeholder="1 pada Tepi"
              name="Tepi"
              ref={tepiInputRef}
              onChange={(e) => handleInputChange(e, "Tepi")}
            ></textarea>
          </div>

          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="result_left">
                <p>
                  <span>Total {props.t("line")}</span> :{" "}
                  {RespCalculateTotal.line ? RespCalculateTotal.line : "-"}
                </p>
                <p>
                  <span>Total {props.t("purchases")}</span> :{" "}
                  {RespCalculateTotal.tover
                    ? formatPrice(RespCalculateTotal.tover)
                    : "-"}{" "}
                  &nbsp;
                </p>
              </div>
              <div className="result_right">
                <p>
                  <span>Total {props.t("discount")}</span>:{" "}
                  {RespCalculateTotal.disc
                    ? formatPricewithdecimal(RespCalculateTotal.disc)
                    : "-"}
                </p>
                <p>
                  <span>Total {props.t("payment")}</span> :{" "}
                  {RespCalculateTotal.pay
                    ? formatPricewithdecimal(RespCalculateTotal.pay)
                    : "-"}
                </p>
              </div>
              <div className="info_icon">
                <img src={infoIcon} alt="" onClick={toggleTooltip} />
                {showTooltip && (
                  <div
                    className="info_icon_overlay"
                    onClick={() => setShowTooltip(false)}
                  ></div>
                )}
                {showTooltip && (
                  <span className="tooltip">
                    <div className="tooltip_wrapper">
                      <span className="tooltip_heading">
                        Contoh Format Taruhan
                      </span>
                      <span className="tooltip_content">
                        1 pada tengah atau tepi
                      </span>
                    </div>
                  </span>
                )}
              </div>
            </div>
            <div className="versiweb_result_right">
              <p>
                Konversi<br></br> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="button_left">
                <button onClick={submitCalculateTotal}>
                  {props.t("count_total")}
                </button>
              </div>
              <div className="button_right">
                <button onClick={allDataReset} className="reset">
                  {props.t('reset')}
                </button>
              </div>
            </div>
            <div className="versiweb_result_right btn_Submit">
              <button onClick={submitProcess} className="submit">
                {props.t('submit')}
              </button>
            </div>
            {showConfirmationPopup && (
              <ConfirmBetDeskonPopup
                onClose={hanldeConfirmationPopupClose}
                submitProcessOk={submitProcessOk}
              />
            )}
            {successPopup && (
              <div className="popup-overlay ">
                <BetSuccessPopup
                  response={SubmitRespData}
                  onClose={() => setSuccessPopup(false)}
                />
              </div>
            )}
            {
              /*---error popup --*/
              showErrorPopup && (
                <ErrorInnerPopup
                  modalTitle={""}
                  modalHeader={true}
                  onCloseModal={() => setShowErrorPopup(false)}
                >
                  <ErrorPopup
                    message={errMessage}
                    onClose={() => setShowErrorPopup(false)}
                  />
                </ErrorInnerPopup>
              )
            }

            {showCancelledPopup && (
              <CancelledBetDeskonPopup
                onClose={() => setShowCanclledPopup(false)}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default withTranslation()(TengahVersiWap);
